
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 18c-1.967 0-3.717-.558-5.25-1.675S4.133 13.767 3.5 12H0v-2h3.05a7.48 7.48 0 01-.062-1.113c.008-.341.029-.637.062-.887H0V6h3.5c.633-1.767 1.717-3.208 3.25-4.325S10.033 0 12 0c1.15 0 2.238.204 3.263.612A9.139 9.139 0 0118 2.3l-1.425 1.4a7.064 7.064 0 00-2.087-1.25A6.834 6.834 0 0012 2c-1.417 0-2.683.37-3.8 1.112A7.094 7.094 0 005.675 6H12v2H5.075c-.067.45-.092.846-.075 1.188.017.341.042.612.075.812H12v2H5.675A7.087 7.087 0 008.2 14.887C9.317 15.629 10.583 16 12 16c.883 0 1.713-.15 2.488-.45.775-.3 1.47-.717 2.087-1.25L18 15.7a9.122 9.122 0 01-2.737 1.687A8.73 8.73 0 0112 18z"}})])
          )
        }
      }
    